/* Imports */
import React from "react"
import { Stepper } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

import commonProps from "../../data/common-props"

const StepperPage = () => {
    const steps = [
        {
            text: "Step",
            to: "#",
        },
        {
            text: "Step",
            to: "#",
        },
        {
            text: "Step",
        },
        {
            text: "Step",
        },
        {
            text: "Step",
        },
    ]

    const items = [
        {
            title: "Row",
            content: <Stepper steps={steps} active={1} />,
            code: 'const steps = [\n    {\n        text: "Step",\n        to: "#",\n    },\n    {\n        text: "Step",\n        to: "#",\n    },\n    {\n        text: "Step",\n    },\n    {\n        text: "Step",\n    },\n    {\n        text: "Step",\n    },\n]\n\n<Stepper steps={steps} active={1} />',
        },
        {
            title: "Column",
            content: <Stepper steps={steps} active={2} direction="column" />,
            code: 'const steps = [\n    {\n        text: "Step",\n        to: "#",\n    },\n    {\n        text: "Step",\n        to: "#",\n    },\n    {\n        text: "Step",\n    },\n    {\n        text: "Step",\n    },\n    {\n        text: "Step",\n    },\n]\n\n<Stepper steps={steps} active={2} direction="column" />',
        },
    ]

    const propsItems = [
        {
            name: "steps",
            type: "Array of objects",
            required: "Yes",
        },
        {
            name: "text (steps Array)",
            type: "String",
            example: "Contact info",
            required: "Yes",
        },
        {
            name: "to (steps Array)",
            type: "String",
            example: "/order/contact-info",
            required: "No",
        },
        {
            name: "active",
            type: "Number",
            example: "3",
            required: "Yes",
        },
        {
            name: "direction",
            type: "String",
            example: "column",
            possible: '"row" | "column"',
            default: "row",
        },
        {
            name: "iconActive",
            type: "String",
            example: "check-circle",
        },
        {
            name: "fajnyIconActive",
            type: "String",
            example: "check-circle-solid",
            possible: commonProps.fajnyIcons,
            default: "check-solid",
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default StepperPage
